<template>
  <div id="app">
    <img alt="Think Soft logo" src="./assets/logo-think.png" class="w-50">
    <h2>Bem vindo a Think Soft Tecnologia</h2>
    <span>Com um time com pessoas apaixonadas pelo que fazem, procuramos sempre desenvolver produtos para ajudar e entreter nossos clientes.</span>
    <br/>
    <br/>
    <home></home>
  </div>
</template>

<script>

import Home from  "./components/Home"

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10% 10% 10%;
}
</style>
